import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../utils/axios';
import ProductCard from '../ProductCard';
import { useTranslation } from 'react-i18next';
import { SlideUp, StaggerContainer, StaggerItem } from '../animations';

const LatestProductsSection = () => {
    const { t } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(t('home.latestProducts.all'));

    const tabs = [
        { id: t('home.latestProducts.all'), label: t('home.latestProducts.all'), categorySlug: '' },
        { id: 'PIRLANTA', label: 'PIRLANTA', categorySlug: 'pirlanta' },
        { id: 'ALTIN', label: 'ALTIN', categorySlug: 'altin' },
        { id: 'GÜMÜŞ', label: 'GÜMÜŞ', categorySlug: 'gumus' },
        { id: 'AKSESUAR', label: 'AKSESUAR', categorySlug: 'aksesuar' }
    ];

    useEffect(() => {
        fetchProducts(tabs.find(t => t.id === activeTab)?.categorySlug || '');
    }, [activeTab]);

    const fetchProducts = async (categorySlug) => {
        try {
            setLoading(true);
            const params = { limit: 8, sort: '-createdAt' };
            if (categorySlug) {
                params.category = categorySlug;
            }
            const { data } = await axios.get('/products', { params });
            setProducts(data.data || []);
        } catch (error) {
            console.error('Ürünler yüklenirken hata:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-white">
            <div className="max-w-[1400px] mx-auto">
                {/* Header */}
                <SlideUp className="text-center mb-12">
                    <span className="block text-[#287968] text-[11px] font-bold tracking-[0.25em] uppercase mb-4">{t('home.latestProducts.subtitle')}</span>
                    <h2 className="text-4xl md:text-5xl font-serif text-[#4a4a4a] mb-6">
                        {t('home.latestProducts.title')}
                    </h2>
                    <div className="w-12 h-[1px] bg-gray-300 mx-auto mb-12"></div>

                    {/* Tabs */}
                    <div className="flex flex-wrap items-center justify-center gap-2 md:gap-8">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`text-[11px] font-bold tracking-[0.2em] uppercase px-6 py-3 transition-colors duration-300 ${
                                    activeTab === tab.id 
                                    ? 'bg-[#1a202c] text-white' 
                                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                                }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </SlideUp>

                {/* Grid */}
                {loading ? (
                    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 mb-16">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="bg-gray-100 rounded-lg aspect-[4/5] animate-pulse" />
                        ))}
                    </div>
                ) : products.length === 0 ? (
                    <div className="text-center text-gray-500 py-12">
                        {t('home.latestProducts.notFound')}
                    </div>
                ) : (
                    <>
                        <StaggerContainer className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 mb-16">
                            {products.map((product) => (
                                <StaggerItem key={product._id}>
                                    <ProductCard product={product} />
                                </StaggerItem>
                            ))}
                        </StaggerContainer>
                        <div className="text-center">
                            <Link to="/products" className="inline-flex items-center gap-4 border border-gray-300 text-gray-900 px-8 py-4 text-xs font-bold tracking-[0.2em] uppercase hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-300">
                                {t('home.latestProducts.viewAll')} <span className="text-lg leading-none">→</span>
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default LatestProductsSection;
